import { render, staticRenderFns } from "./ruleDialog.vue?vue&type=template&id=a7125350"
import script from "./ruleDialog.vue?vue&type=script&lang=js"
export * from "./ruleDialog.vue?vue&type=script&lang=js"
import style0 from "./ruleDialog.vue?vue&type=style&index=0&id=a7125350&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports